<template>
  <div>
    <div class="row">
      <div class="col text-center">
        <component
          v-if="!this.loading"
          v-bind:is="simpleComponent"
          :user="user"
          :sign-configuration="signConfiguration"
          :requestData="requestData"
          :ambit="ambit"
          key="simple-sign"
          @activate="activationReload"
          @cancel="cancel"
        />
        <b-spinner
          small
          v-if="this.loading"
          variant="primary"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import SimpleSignFebos from '@/febos/global/usuario/components/sign/simple/febos/SimpleSignFebos';
import { getUserSign } from '@/febos/servicios/api/usuarios.api';
import AvanzadaSignFirmadorministerioeconomia
from '@/febos/global/usuario/components/sign/advanced/ministerioEconomia/AvanzadaSignFirmadorministerioeconomia';
import AvanzadaSignSegpres
from '@/febos/global/usuario/components/sign/advanced/segpres/AvanzadaSignSegpres';
import AvanzadaSignEsign7
from '@/febos/global/usuario/components/sign/advanced/eSign/AvanzadaSignEsign7';
import { capitalize } from '@/febos/global/utils/configurations';
import SimpleSignSAgile from '@/febos/global/usuario/components/sign/simple/agile/SimpleSignSAgile';
import SimpleSignEDigital from '@/febos/global/usuario/components/sign/simple/edigital/SimpleSignEDigital';
import SimpleSignSignapiExterno from '@/febos/global/usuario/components/sign/simple/signapiExterno/SimpleSignSignapiExterno';
import AvanzadaSignApi from '@/febos/global/usuario/components/sign/advanced/aSignApi/AvanzadaSignApi';

export default {
  components: {
    'simple-sign-sagile': SimpleSignSAgile,
    'simple-sign-edigital': SimpleSignEDigital,
    'simple-sign-s_signapi_e': SimpleSignSignapiExterno,
    SimpleSignFebos,
    AvanzadaSignEsign7,
    AvanzadaSignFirmadorministerioeconomia,
    AvanzadaSignSegpres,
    'avanzada-sign-asignapi': AvanzadaSignApi
  },
  data() {
    return {
      loading: false,
      actualPassword: '',
      newPassword: '',
      confirmationNewPassword: '',
      signConfiguration: {},
      requestData: {}
    };
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    ambit: {
      type: String,
      required: false,
      default: 'perfil'
    },
    type: {
      type: String,
      required: false,
      default: 'simple'// "avanzada"
    }
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    simpleComponent() {
      return `${this.type}-sign-${this.company[`firma${capitalize(this.type)}`].toLowerCase()}`;
    }
  },
  methods: {
    async cancel() {
      this.$emit('cancel');
    },
    async loadSignConfig() {
      try {
        this.loading = true;
        const response = await getUserSign(
          `firma${capitalize(this.type)}`,
          this.company[`firma${capitalize(this.type)}`],
          this.ambit,
          this.user.id
        );
        this.signConfiguration = response.data.parametros;
        this.requestData = response.data;
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    activationReload() {
      this.loadSignConfig();
      this.$bvToast.toast(
        'Cambios guardados correctamente',
        {
          title: `Firma ${capitalize(this.type)}`,
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
    }
  },
  created() {
    this.loadSignConfig();
  }
};
</script>
<style scoped>
.message {
  font-weight: normal;
  background: #ea7037;
  color: white;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
  padding: 10px;
}
</style>
